(function (angular, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Services").service("LocationManager", [
    "API",
    "Geodecode",
    "Location",
    "Dealer",
    "Region",
    "Postcodes",
    "ToastManager",
    "DealerInventoryService",
    "$q",
    "$filter",
    "$rootScope",
    function (
      API,
      Geodecode,
      Location,
      Dealer,
      Region,
      Postcodes,
      ToastManager,
      DealerInventoryService,
      $q,
      $filter,
      $rootScope
    ) {
      var exports = this;

      exports.getLocationObject = function () {
        return Location.get();
      };

      exports.setDefaultDealerAndResetSavedDealer = function (dealer) {
        Dealer.updateDefault(dealer);
        Dealer.clearSaved();
      };

      exports.triggerDidLocationChangeDealersLoadBegin = function () {
        $rootScope.$broadcast("did-location-change-dealers-load-begin");
      };

      exports.triggerDidLocationChangeDealersLoadEnd = function () {
        $rootScope.$broadcast("did-location-change-dealers-load-end");
      };

      exports.fetchDealers = function (postcode, suburb, checkLocalStock) {
        var servicetype = "new";
        var dealers = [];
        var dealersURL = $filter("formatArgs")(ToyotaConsts.API.Info.DealersByServiceType, [
          postcode,
          suburb,
          servicetype,
        ]);
        var getDealersPromise = API.get(dealersURL);

        return getDealersPromise.then(
          // success
          function (req) {
            if (!req.data || req.data.results.length === 0) {
              return $q.reject();
            }

            dealers = req.data.results;

            if (checkLocalStock && checkLocalStock.loadPage) {
              var dealerChain = [];

              // hold showing the dealers while we fetch the stock URLs for all of them
              angular.forEach(dealers, function (dealer, key) {
                var promise = DealerInventoryService.get(dealer, checkLocalStock.materialCode).then(function (result) {
                  if (result.data.success) {
                    dealers[key].stockUrl = result.data.url;
                  }
                });

                dealerChain.push(promise);
              });
              return $q.all(dealerChain).then(function () {
                return $q.resolve(dealers);
              });
            }

            return $q.resolve(dealers);
          },
          // failed
          function () {
            /*
             * Created tech debt to address this
             * https://toyotaau.atlassian.net/browse/SIR-4580
             */
          }
        );
      };

      exports.getCurrentLocation = function (errorMessageInvalidCountryToast) {
        return Geodecode().then(
          // success
          function (response) {
            if (response.isSuccessful) {
              return Promise.all([
                Region(response.data.postcode, response.data.suburb),
                Postcodes(response.data.postcode, 1),
              ]).then(function ([region, tags]) {
                return $q.resolve({
                  postcode: response.data.postcode,
                  suburb: response.data.suburb,
                  state: response.data.state,
                  region: region,
                  pricingZone: tags?.[0]?.tagInfo?.pricingZone,
                });
              });
            }

            return $q.reject(response);
          },
          // failed
          function (response) {
            if (
              typeof response.message === "string" &&
              response.message.match(/^Invalid country code/) &&
              !Location.getHasShownInvalidCountryToast()
            ) {
              ToastManager.triggerBriefToast(errorMessageInvalidCountryToast, "location-change");
              Location.setHasShownInvalidCountryToast(true);
            }

            return $q.reject(response);
          }
        );
      };

      /*
       * these two functions below are used to support the functionality of the Current Offers component
       * previous saved/default dealer and location are considered one single state
       * the previous state will only update when a saved dealer changes
       * the intention here is to be able to revert the values back to the last saved dealer state
       */
      exports.setPrevSavedDealerState = function (defaultDealer, savedDealer) {
        Dealer.updatePrevSaved(defaultDealer, savedDealer);
      };

      exports.setPrevSavedLocation = function () {
        Location.updatePrevSavedLocation(Location.get());
      };

      return exports;
    },
  ]);
})(window.angular, window.ToyotaConsts);
